import { CONFERENCE_FAILED } from '../../../react/features/base/conference/actionTypes';
import { JitsiConferenceErrors } from '../../../react/features/base/lib-jitsi-meet';
import { LOCAL_PARTICIPANT_RAISE_HAND } from '../../../react/features/base/participants/actionTypes';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { hideNotification, showNotification } from '../../../react/features/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE, NOTIFICATION_TYPE } from '../../../react/features/notifications/constants';
import { iAmVisitor } from '../../../react/features/visitors/functions';
import { isUserByIdSpeaker } from '../../../x-bees/components/webinar/functions';
import { toggleVisitorMuteButton } from '../customStorageSettings/actions';
import { wildixRemoveFromConferenceByPlatform } from './actions';
import { VISITOR_MUTE_NOTIFY } from './constants';
/**
 * Implements the entry point of the middleware of the xbees/base/conference.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case LOCAL_PARTICIPANT_RAISE_HAND: {
            const { getState, dispatch } = store;
            const state = getState();
            if (iAmVisitor(state) && !isUserByIdSpeaker(state)) {
                const { raisedHandTimestamp } = action;
                dispatch(hideNotification(VISITOR_MUTE_NOTIFY));
                dispatch(toggleVisitorMuteButton(Boolean(raisedHandTimestamp)));
                if (raisedHandTimestamp) {
                    dispatch(showNotification({
                        titleKey: 'notify.visitorMuteTitle',
                        descriptionKey: 'notify.visitorMuteDescription',
                        uid: VISITOR_MUTE_NOTIFY,
                        appearance: NOTIFICATION_TYPE.WARNING
                    }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                }
            }
            break;
        }
        case CONFERENCE_FAILED: {
            const errorName = action.error?.name;
            if (errorName === JitsiConferenceErrors.CONFERENCE_DESTROYED
                || errorName === JitsiConferenceErrors.FOCUS_LEFT) {
                const { dispatch } = store;
                dispatch(wildixRemoveFromConferenceByPlatform());
            }
            break;
        }
    }
    return next(action);
});
